import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import Stars from '../elements-stars/stars';
import { ReviewerTypes, getReviewDate, getReviewerName } from './reviews-utils';

export const Review = ({ review, intl }) => {
  const activityType = (
    review.normalized_activity_type ||
    review.use_type ||
    ''
  ).toLowerCase();

  return (
    <div className='padding-md-bottom border-bottom'>
      <p className='heavier text-gray-800'>
        <Link to={`/profiles/${review.reviewer_id}`}>
          {getReviewerName(review, intl)}
        </Link>
        <FormattedMessage
          id='reviews.review.review_text'
          defaultMessage=' {reviewerTypeText} {aOrAn} {activityType} for {numberOfGuests} people'
          values={{
            reviewerTypeText:
              review.reviewer_type === ReviewerTypes.HOST ? (
                <FormattedMessage
                  id='reviews.review.hosted'
                  defaultMessage='hosted'
                />
              ) : review.reviewer_type === ReviewerTypes.ATTENDEE ? (
                <FormattedMessage
                  id='reviews.review.attended'
                  defaultMessage='attended'
                />
              ) : (
                <FormattedMessage
                  id='reviews.review.booked'
                  defaultMessage='booked'
                />
              ),
            aOrAn: /^[aeiou].*/i.test(activityType) ? (
              <FormattedMessage id='reviews.review.an' defaultMessage='an' />
            ) : (
              <FormattedMessage id='reviews.review.a' defaultMessage='a' />
            ),
            activityType,
            numberOfGuests: review?.booking?.number_of_guests
          }}
        />
      </p>

      <div className='flex middle margin-md-top margin-md-bottom'>
        <Stars reviewStars={review.stars} />
        {review.reviewer_type !== ReviewerTypes.ATTENDEE && (
          <span className='margin-xl-left flex middle'>
            <i
              className={`ico ico-lg ${
                review.would_you_book_again ? 'icon-yes' : 'icon-no'
              }`}
            />
            <span className='margin-md-left text-small'>
              {review.would_you_book_again ? (
                <FormattedMessage
                  id='reviews.review.book_again_yes'
                  defaultMessage='Yes, I would {reviewerTypeText} again.'
                  values={{
                    reviewerTypeText:
                      review.reviewer_type === ReviewerTypes.HOST ? (
                        <FormattedMessage
                          id='reviews.review.host'
                          defaultMessage='host'
                        />
                      ) : review.reviewer_type === ReviewerTypes.ATTENDEE ? (
                        <FormattedMessage
                          id='reviews.review.attend'
                          defaultMessage='attend'
                        />
                      ) : (
                        <FormattedMessage
                          id='reviews.review.book'
                          defaultMessage='book'
                        />
                      )
                  }}
                />
              ) : (
                <FormattedMessage
                  id='reviews.review.book_again_no'
                  defaultMessage='No, I would not {reviewerTypeText} again.'
                  values={{
                    reviewerTypeText:
                      review.reviewer_type === ReviewerTypes.HOST ? (
                        <FormattedMessage
                          id='reviews.review.host'
                          defaultMessage='host'
                        />
                      ) : review.reviewer_type === ReviewerTypes.ATTENDEE ? (
                        <FormattedMessage
                          id='reviews.review.attend'
                          defaultMessage='attend'
                        />
                      ) : (
                        <FormattedMessage
                          id='reviews.review.book'
                          defaultMessage='book'
                        />
                      )
                  }}
                />
              )}
            </span>
          </span>
        )}
      </div>

      <p className='margin-lg-bottom'>{review.review_text}</p>

      <span className='text-gray'>
        <FormattedDate
          value={getReviewDate(review)}
          year='numeric'
          month='long'
          day='numeric'
        />
      </span>
    </div>
  );
};
